<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="layout-container" *ngIf="salesPageVisible">
    <app-point-of-sales [isCollapsed]="isCollapsed"></app-point-of-sales>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()" [hideBtnToggler]="true"></app-top-bar>
        <div class="content-area p-2">
            <div class="container-fluid">
                <app-passcodeAuth (passcodeAuthenciate)="passcodeAuthenciateRes($event)"></app-passcodeAuth>
                <form [formGroup]="customerSalesForm">
                    <div class="row">
                        <main class="col-md-12 px-2 py-1">
                            <div class="pos-topbar d-flex flex-wrap align-items-center justify-content-between pt-0">
                                <div class="d-flex flex-wrap align-items-center gap-2 mt-2">
                                    <label class="form-label mb-0 me-1">Invoice #</label>
                                    <input type="text" class="form-control form-control-sm" style="width: 120px;"
                                        formControlName="invoiceNo" (keyup.enter)="onInvoiceSearch()"
                                        (change)="onInvoiceSearch()" appNumericInput>
                                    <button type="button" class="btn pos-dark-btn btn-sm" [disabled]="pendingSale"
                                        (click)="openModalById('invoiceModal');resetInvoiceFormAndLoad()"><img
                                            src="./assets/images/search.svg" class="img-fluid" /></button>
                                    <select class="form-select form-select-sm" style="width: 180px;"
                                        *ngIf="layawayReceiptDropdown.length > 0" [(ngModel)]="selectedLayawayReceiptId"
                                        (ngModelChange)="onLayawayReceiptSelectionChange($event)"
                                        [ngModelOptions]="{ standalone: true }">
                                        <option *ngFor="let receipt of layawayReceiptDropdown"
                                            [ngValue]="receipt.SalesRectId">
                                            {{receipt.SalesRectId}} {{receipt.ReceiptType}}
                                        </option>
                                    </select>
                                </div>

                                <div class="d-flex flex-wrap align-items-center gap-2 mt-2">
                                    <label class="form-label mb-0 me-1 fw-bold"
                                        style="color: red;font-size: 24px !important;">{{saleStatus}}</label>
                                </div>

                                <div class="d-flex flex-wrap align-items-center gap-2 mt-2"
                                    *ngIf="currentMenu == '6' || currentMenu == '1' || currentMenu == '2'">
                                    <label class="form-label mb-0 me-1">Pending Sale</label>
                                    <select class="form-select" style="width: 160px;"
                                        formControlName="selectedPendingSale" (change)="loadPendingSale()">
                                        <option value="0" disabled>Select</option>
                                        <option *ngFor="let item of recentPendingSaleList" [value]="item.SeqInvoiceNo">
                                            {{item.PendingSaleData}}
                                        </option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center gap-2 mt-3">
                                    <button type="button" class="btn pos-dark-btn btn-sm" *ngIf="invoiceNo"
                                        (click)="printReceipt(false,true,false, selectedLayawayReceiptId || currentSalesReceiptId)"><img
                                            src="./assets/images/print-white.svg" class="img-fluid" /></button>
                                    <button type="button" class="btn pos-dark-btn btn-sm" *ngIf="invoiceNo"
                                        (click)="openInvoiceEmailModel()"><img src="./assets/images/email-white.svg"
                                            class="img-fluid" /></button>
                                    <button type="button" class="btn pos-dark-btn btn-sm" *ngIf="invoiceNo"
                                        (click)="printReceipt(true,false,false, selectedLayawayReceiptId || currentSalesReceiptId)"><img
                                            src="./assets/images/view-white.svg" class="img-fluid" /></button>
                                    <button type="button" class="btn btn-orange btn-sm" (click)="addBag()" *ngIf="showAddBag">Add
                                        Bag</button>
                                    <button type="button" class="btn pos-dark-btn btn-sm" (click)="openDiscountCoupon()" *ngIf="!antiqueVillageChanges">Discount
                                        Coupon</button>
                                </div>
                            </div>

                            <div class="vendor-section shadow-sm mt-2">
                                <div class="row gx-1 align-items-start">

                                    <div class="col-lg-2">
                                        <div class="d-flex flex-column">
                                            <span class="vendor-label">{{ 'Vendor Info' | wordReplace }}:</span>
                                            <span>{{ vendorName }}</span>
                                            <span>{{ vendorPhone | phoneFormat}}</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-1">
                                        <div class="d-flex flex-column">
                                            <span class="vendor-label">{{ 'Booth#' | wordReplace }}:</span>
                                            <span class="booth-text">{{ boothList }}</span>
                                        </div>
                                    </div>

                                    <div class="col-lg-2 d-flex align-items-center">
                                        <label class="vendor-label me-2 mb-0">
                                            {{ 'Vendor Comments:' | wordReplace }}
                                        </label>
                                        <textarea type="text" class="form-control form-control-sm" rows="3"
                                            formControlName="vendorComments"></textarea>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="d-flex align-items-start">
                                            <label class="vendor-label me-2 mt-2 mb-0">Customer Info:</label>
                                            <textarea class="form-control form-control-sm me-1" rows="3" readonly
                                                style="white-space: pre-line; text-align: left;">
                                                                                                                            {{ customerData?.FirstName }} {{ customerData?.LastName }}
                                                                                                                            {{ customerData?.Address }}
                                                                                                                            {{ customerData?.City }}, {{ customerData?.StateId }} {{ customerData?.Zip }}
                                                                                                                        </textarea>

                                            <div class="d-flex align-items-start mt-2">
                                                <button type="button" class="pos-dark-btn me-1"
                                                    (click)="openCustomerForm('search');openModalById('customerModal')"
                                                    [disabled]="disableCustomerChange()">
                                                    <img src="./assets/images/search.svg" />
                                                </button>

                                                <div class="d-flex flex-column">
                                                    <button type="button" class="btn btnAS btn-sm mb-1"
                                                        (click)="openCustomerForm('new');openModalById('customerModal')"
                                                        [disabled]="disableCustomerChange()">
                                                        New
                                                    </button>
                                                    <button type="button" class="btn btnAS btn-sm mb-1"
                                                        [disabled]="!existingCustomer || disableCustomerChange()"
                                                        (click)="openCustomerForm('edit');openModalById('customerModal')">
                                                        Update
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-3">
                                        <div class="d-flex flex-column ms-lg-4">
                                            <div class="d-flex align-items-center mb-2" *ngIf="trackSalesbyPerson">
                                                <label class="form-label mb-0 me-2">Sales Person</label>
                                                <select class="form-select form-select-sm" style="width:199px;"
                                                    formControlName="salesPersonId">
                                                    <option value="0">Select</option>
                                                    <option *ngFor="let item of salesPersonData"
                                                        [value]="item.SalesmanId">
                                                        {{ item.SalesmanId }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="d-flex align-items-center pt-3" *ngIf="vendorDiscountText">
                                                <label class="vendor-label mb-0 me-4 pe-2">Discount:</label>
                                                <textarea class="form-control form-control-sm" style="color: red;"
                                                    rows="3" readonly>{{ vendorDiscountText }}</textarea>
                                            </div>
                                            <div class="d-flex align-items-center pt-3"
                                                *ngIf="noDiscountPlan && !vendorDiscountText">
                                                <label class="vendor-label mb-0 me-4 pe-2">Discount:</label>
                                                <span style="color: red; font-style: italic;">No discount plans defined
                                                    for this vendor</span>
                                            </div>

                                            <div class="d-flex align-items-center mb-2" *ngIf="currentMenu == 'gc'">
                                                <label class="form-label mb-0 me-2">GC#</label>
                                                <input type="text" class="form-control form-control-sm"
                                                    formControlName="gcNo" (input)="sanitizeGcNo($event)"
                                                    (change)="validateGCNo()" maxlength="16">
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row" *ngIf="useBarcodeScanner">
                                    <div class="col-lg-6 text-start mt-1">
                                        <div class="d-flex align-items-center gap-4">

                                            <div class="d-flex align-items-center">
                                                <label class="form-label mb-0 me-2">Barcode Scanner</label>
                                                <div class="custom-toggle-container">
                                                    <input type="checkbox" id="InventoryToggle" class="custom-toggle"
                                                        formControlName="barcodeScanner" />
                                                    <label for="InventoryToggle" class="custom-toggle-label"></label>
                                                </div>
                                            </div>

                                            <div class="form-check d-flex align-items-center">
                                                <input type="checkbox" id="noScanner" class="form-check-input me-2"
                                                    formControlName="defaultNoScanner" />
                                                <label for="noScanner" class="form-check-label mb-0">
                                                    No Scanner
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-section mt-2 py-3 pb-4">
                                <div class="row g-2 align-items-end">
                                    <div class="col-md-3 col-lg-1"
                                        *ngIf="posTransactionByVendor && currentMenu != 'gc'">
                                        <label class="form-label">{{'Vendor ID' | wordReplace}}</label>
                                        <input type="text" class="form-control form-control-sm"
                                            formControlName="vendorId"
                                            (blur)="getEnteredVendorDetails(customerSalesForm.get('vendorId')?.value)"
                                            #vendorIdField appEnterAsTab>
                                    </div>
                                    <div class="col-md-3 col-lg-1"
                                        *ngIf="(!posTransactionByVendor || antiqueVillageChanges) && currentMenu != 'gc'">
                                        <label class="form-label">{{ posTransactionByVendor ? 'Shop Id' : ('Booth ID' |
                                            wordReplace) }}</label>
                                        <input type="text" class="form-control form-control-sm"
                                            formControlName="boothId" (blur)="getVendorById()" boothId appEnterAsTab
                                            [readonly]="(posTransactionByVendor && !antiqueVillageChanges)">
                                    </div>
                                    <div class="col-auto" *ngIf="currentMenu != 'gc'">
                                        <label class="form-label">&nbsp;</label>
                                        <button type="button" class="btn btn-dark-custom btn-sm w-100"
                                            (click)="setVendorValue();openModalById('vendorModal')"
                                            [disabled]="invoiceNo && !this.pendingSale" tabindex="-1">
                                            <img src="./assets/images/search.svg" class="img-fluid" />
                                        </button>
                                    </div>
                                    <div class="col-md-3 col-lg-1">
                                        <label class="form-label">Stock ID</label>
                                        <input type="text" class="form-control form-control-sm"
                                            formControlName="stockId"
                                            (focus)="stockIdOnFocus = customerSalesForm.get('stockId')?.value || ''"
                                            (blur)="validateStockId()" (keydown)="onStockIdKeyDown($event)"
                                            appEnterAsTab maxlength="30" #stockIdInput>
                                    </div>
                                    <div class="col-auto" *ngIf="currentMenu != 'gc'">
                                        <label class="form-label">&nbsp;</label>
                                        <button type="button" class="btn btn-dark-custom btn-sm w-100"
                                            [disabled]="invoiceNo && !this.pendingSale" tabindex="-1"
                                            (click)="openInventoryList()"><img src="./assets/images/search.svg"
                                                class="img-fluid" /></button>
                                    </div>

                                    <div class="col-md-4 col-lg-2">
                                        <label class="form-label">Item Description</label>
                                        <input type="text" class="form-control form-control-sm"
                                            formControlName="itemDescription" [readonly]="currentMenu == 'gc'"
                                            #itemDescriptionInput maxlength="100" appRequireBeforeAdvance>
                                    </div>

                                    <div class="col-md-3 col-lg-1" *ngIf="currentMenu != 'gc'">
                                        <label class="form-label">Qty</label>
                                        <input type="number" class="form-control form-control-sm"
                                            formControlName="itemQty" min="1" #itemQtyInput appNegativePositiveNumber
                                            appEnterAsTab>
                                    </div>

                                    <div class="col-md-4 col-lg-2" *ngIf="currentMenu == 'gc'">
                                        <label class="form-label">Start Date</label>
                                        <ejs-datepicker format='MM/dd/yyyy' formControlName="gcStartDate"
                                            class="form-control p-0" (ngModelChange)="updateExpiryDate()"
                                            [min]="minDate"></ejs-datepicker>
                                    </div>
                                    <div class="col-md-3 col-lg-1" *ngIf="currentMenu == 'gc'">
                                        <label class="form-label">Max Days</label>
                                        <input class="col-3 form-control form-control-sm" type="text"
                                            formControlName="gcMaxDays" (input)="updateExpiryDate()" appEnterAsTab />
                                    </div>
                                    <div class="col-md-4 col-lg-2" *ngIf="currentMenu == 'gc'">
                                        <label class="form-label">Expiry Date</label>
                                        <ejs-datepicker format='MM/dd/yyyy' formControlName="gcExpiryDate"
                                            class="form-control p-0" [min]="minDate"></ejs-datepicker>
                                    </div>

                                    <div class="col-md-3 col-lg-1">
                                        <label class="form-label">Rate</label>
                                        <input type="text" class="form-control form-control-sm text-end"
                                            formControlName="itemRate" (blur)="onAmountFormat('itemRate')"
                                            (keypress)="numberOnlyMaxDecimals($event, 4)" appRemoveCurrencyFormatting
                                            (focus)="selectAll($event)" #itemRateInput appRequireBeforeAdvance
                                            [appRequireBeforeAdvanceValid]="isItemRateEnteredForAdvance">
                                    </div>

                                    <div class="col-md-3 col-lg-1" *ngIf="allowVendorDiscount && currentMenu != 'gc'">
                                        <div class="form-check mb-1" *ngIf="antiqueVillageChanges">
                                            <input class="form-check-input me-2" type="checkbox" id="itemFirm"
                                                formControlName="itemFirm" (change)="onFirmChange()" appEnterAsTab>
                                            <label class="form-check-label small" for="itemFirm">Firm</label>
                                        </div>
                                        <label class="form-label">Discount</label>
                                        <select class="form-select form-select-sm" formControlName="itemDiscType"
                                            [disabled]="customerSalesForm.get('itemFirm')?.value" appEnterAsTab>
                                            <option value="2" selected>%</option>
                                            <option value="1">$</option>
                                        </select>
                                    </div>

                                    <div class="col-md-3 col-lg-1" *ngIf="allowVendorDiscount && currentMenu != 'gc'">
                                        <label class="form-label"> Disc ({{ customerSalesForm.get('itemDiscType')?.value
                                            === '1' ?
                                            '$' : '%' }})</label>
                                        <div class="flex-grow-1 position-relative">
                                            <input type="text" class="form-control" formControlName="itemDiscValue"
                                                (focus)="showDropdown = true" (blur)="hideDropdownWithDelay()"
                                                (keydown)="onDiscountKeydown($event)"
                                                (keypress)="numberOnlyMaxDecimals($event, 4)"
                                                [disabled]="checkItemPrice()" appEnterAsTab />

                                            <ul class="list-group position-absolute top-100 start-0" style="width: 200px; z-index: 1050;"
                                                *ngIf="showDropdown && !customerSalesForm.get('itemFirm')?.value && isPercentDiscountType() && discountOptions.length > 0">
                                                <li class="list-group-item list-group-item-action"
                                                    *ngFor="let discount of discountOptions; let i = index"
                                                    [class.active]="i === activeIndex"
                                                    (mousedown)="selectDiscount(discount)">
                                                    {{ discount.DiscountPercent }}
                                                </li>
                                                <li class="list-group-item list-group-item-action"
                                                    [class.active]="activeIndex === discountOptions.length"
                                                    (mousedown)="selectDiscount(null)">
                                                    No discount
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-1" *ngIf="showCommissiononPos && currentMenu != 'gc'">
                                        <label class="form-label">Comm(%)</label>
                                        <input type="text" class="form-control form-control-sm"
                                            formControlName="itemCommission" appEnterAsTab>
                                    </div>
                                    <!-- <div class="col-md-1 d-flex align-items-center mt-4"></div> -->


                                    <div class="col-auto mt-4">
                                        <div class="form-check" *ngIf="currentMenu != 'gc'">
                                            <input class="form-check-input me-2" type="checkbox" id="noTax"
                                                formControlName="itemNoTax" appEnterAsTab>
                                            <label class="form-check-label small" for="noTax">No Tax</label>
                                        </div>
                                        <button type="button" class="btn btn-dark-custom btn-sm"
                                            style="background-color: white; color: #0c0c22" *ngIf="addNewItem"
                                            (click)="addItemsToGrid()"
                                            [disabled]="(invoiceNo && !this.pendingSale) || isAddingItemToGrid"
                                            style="background-color: white !important; color: #0c0c22 !important; width: 55px; min-width: 55px;">ADD</button>
                                        <button type="button" class="btn btn-dark-custom btn-sm"
                                            *ngIf="updateExistingItem" (click)="addItemsToGrid()"
                                            [disabled]="(invoiceNo && !this.pendingSale) || isAddingItemToGrid">Update</button>
                                        <button type="button" class="btn btn-orange btn-sm ms-1"
                                            (click)="confirmClearItem()" [disabled]="invoiceNo && !this.pendingSale"
                                            tabindex="-1" style="width: 55px; min-width: 55px;">Clear</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-start">
                                    <div style="overflow-x: scroll;">
                                        <table class="table table-bordered mt-2">
                                            <thead class="table-dark">
                                                <tr>
                                                    <th *ngIf="currentMenu == '7'"></th>
                                                    <th>#</th>
                                                    <th class="text-start" *ngIf="posTransactionByVendor">{{'Vendor ID'
                                                        | wordReplace}}</th>
                                                    <th class="text-start"
                                                        *ngIf="!posTransactionByVendor || antiqueVillageChanges">
                                                        {{'Booth ID' | wordReplace}}</th>
                                                    <th class="text-start">Stock ID</th>
                                                    <th class="text-start">Item Description</th>
                                                    <th>Qty</th>
                                                    <th class="text-end">Rate</th>
                                                    <th class="text-end">Price</th>
                                                    <th>Disc%</th>
                                                    <th class="text-end">Disc. Amt</th>
                                                    <th class="text-end">Disc. Price</th>
                                                    <th class="text-end">No Tax</th>
                                                    <th
                                                        *ngIf="applySalesTaxItemWise && applySalesTax && currentMenu != 'gc'">
                                                        STax
                                                    </th>
                                                    <th
                                                        *ngIf="applySalesTaxItemWise && applySecLvlTax && currentMenu != 'gc'">
                                                        {{secondLevelTaxName}}</th>
                                                    <th class="text-end">Net Price</th>
                                                    <th *ngIf="!invoiceNo || pendingSale"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of customerItemList; let i = index"
                                                    (click)="rowDataClick(item,i)">
                                                    <td *ngIf="currentMenu == '7'">
                                                        <input type="checkbox" [(ngModel)]="item.Selected"
                                                            [ngModelOptions]="{standalone: true}"
                                                            (change)="selectReturnItem(item, $event.target.checked)"
                                                            (click)="$event.stopPropagation()" />
                                                    </td>
                                                    <td>{{ !invoiceNo || (invoiceNo && pendingSale) ? i + 1 :
                                                        item.SerialNumber}}</td>
                                                    <td class="text-start" *ngIf="posTransactionByVendor">
                                                        {{item.VendorId}}</td>
                                                    <td class="text-start"
                                                        *ngIf="!posTransactionByVendor || antiqueVillageChanges">
                                                        {{item.BoothId}}</td>
                                                    <td class="text-start">{{item.StockId}}</td>
                                                    <td class="text-start">{{item.ItemDescription}}</td>
                                                    <td>{{item.ItemQty}}</td>
                                                    <td class="text-end">{{item.ItemRate}}</td>
                                                    <td class="text-end">{{item.ItemTotalRate}}</td>
                                                    <td>{{item.ItemDiscValue}}</td>
                                                    <td class="text-end">{{item.ItemDiscAmount}}</td>
                                                    <td class="text-end">{{item.ItemDiscountedPrice}}</td>
                                                    <td class="text-end">
                                                        <input type="checkbox" class="form-check-input me-2"
                                                            [checked]="item.TaxNotApplied" disabled />
                                                    </td>
                                                    <td class="text-end"
                                                        *ngIf="applySalesTaxItemWise && applySalesTax && currentMenu != 'gc'">
                                                        {{item.ItemSalesTax}}
                                                    </td>
                                                    <td class="text-end"
                                                        *ngIf="applySalesTaxItemWise && applySecLvlTax && currentMenu != 'gc'">
                                                        {{item.ItemSecLvlTax}}
                                                    </td>
                                                    <td class="text-end">{{item.ItemNetprice}}</td>
                                                    <td *ngIf="!invoiceNo || pendingSale">
                                                        <a><img src="./assets/images/delete.svg" class="img-fluid"
                                                                (click)="deleteAddedItem(i)" /></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot *ngIf="!itemVoidorRetn">
                                                <tr class="table-total-row">
                                                    <td [attr.colspan]="antiqueVillageChanges ? (currentMenu == '7' ? 6 : 5) : (currentMenu == '7' ? 5 : 4)"
                                                        class="text-start bgFooter">
                                                        TOTAL</td>
                                                    <td class="bgFooter">{{ getTotalQty('ItemQty') }}</td>
                                                    <td class="bgFooter"></td>
                                                    <td class="bgFooter text-end">{{ getTotal('ItemTotalRate') }}</td>
                                                    <td class="bgFooter"></td>
                                                    <td class="bgFooter text-end">{{ getTotal('ItemDiscAmount') }}</td>
                                                    <td class="bgFooter text-end">{{ getTotal('ItemDiscountedPrice') }}
                                                    </td>
                                                    <td class="bgFooter"></td>
                                                    <td class="bgFooter text-end"
                                                        *ngIf="applySalesTaxItemWise && applySalesTax && currentMenu != 'gc'">
                                                        {{
                                                        getTotal('ItemSalesTax') }}</td>
                                                    <td class="bgFooter text-end"
                                                        *ngIf="applySalesTaxItemWise && applySecLvlTax && currentMenu != 'gc'">
                                                        {{
                                                        getTotal('ItemSecLvlTax') }}</td>
                                                    <td class="bgFooter text-end">{{ getTotal('ItemNetprice') }}</td>
                                                    <td class="bgFooter" *ngIf="!invoiceNo || pendingSale"></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="my-3">
                                <hr />
                            </div>
                            <div class="row">
                                <div class="col-md-6 text-start" *ngIf="currentMenu == '3'">
                                    <div class="d-flex align-items-start">
                                        <label class="vendor-label me-2 mt-2 mb-0">Shipping Info:</label>
                                        <textarea class="form-control form-control-sm me-1" rows="3" readonly
                                            style="white-space: pre-line; text-align: left;">
                                                                                                                             {{ shipperData?.FirstName }} {{ shipperData?.LastName }}
                                                                                                                              {{ shipperData?.Address }}
                                                                                                                              {{ shipperData?.City }}, {{ shipperData?.StateId }} {{ shipperData?.Zip }}
                                                                                                                            </textarea>

                                        <div class="d-flex align-items-start mt-2">
                                            <button type="button" class="pos-dark-btn me-1"
                                                (click)="openShipperForm('search');openModalById('shipperModal')">
                                                <img src="./assets/images/search.svg" />
                                            </button>
                                            <div class="d-flex flex-column">
                                                <button type="button" class="btn btnAS btn-sm mb-1"
                                                    (click)="openShipperForm('new');openModalById('shipperModal')">
                                                    New
                                                </button>
                                                <button type="button" class="btn btnAS btn-sm mb-1"
                                                    [disabled]="!existingShipper"
                                                    (click)="openShipperForm('edit');openModalById('shipperModal')">
                                                    Update
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto" *ngIf="stockImageUrl">
                                    <label class="form-label">&nbsp;</label>
                                    <img [src]="stockImageUrl" class="img-fluid rounded" alt="Stock image"
                                        style="height: 125px; width: 125px; object-fit: cover;" />
                                </div>
                                <div class="col-md-12 text-strt">
                                    <button type="button" class="btn btn-orange me-1" (click)="scrapPendingSale()"
                                        *ngIf="currentMenu == '6' && invoiceNo && userTerminal && userTerminal != 0">Scrap
                                        Pending Sale</button>
                                </div>
                                <div class="col-md-12 mt-3" *ngIf="currentMenu == '6' && isScrapReasonVisible">
                                    <label for="scrapReason">Reason for Scrap:</label>
                                    <textarea id="scrapReason" class="form-control" formControlName="scrapReason"
                                        rows="3" maxlength="300"></textarea>
                                </div>

                                <div class="col-md-12 text-end" *ngIf="currentMenu == '6'">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="printReceipt" checked
                                            formControlName="printReceipt">
                                        <label class="form-check-label" for="printReceipt">Print Receipt</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="displayReceipt"
                                            formControlName="displayReceipt">
                                        <label class="form-check-label" for="displayReceipt">Display Receipt</label>
                                    </div>
                                </div>

                                <div class="row" *ngIf="enableOtherChargeinPos">
                                    <div class="col-md-9"></div>
                                    <div class="col-md-3 text-end">
                                        <label class="form-label">{{posotherChargeName}}</label>
                                        <input type="text" class="form-control form-control-sm text-end"
                                            style="margin-bottom: 5px;" formControlName="otherCharge"
                                            (keypress)="numberOnlyWithNegative($event)" appRemoveCurrencyFormatting
                                            appCurrencyFormatter (change)="calculateLayaway()"
                                            [readonly]="(!pendingSale && invoiceNo) || updateExistingItem"
                                            (click)="onOtherChargeClick()" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-6"
                                        *ngIf="currentMenu == '5' && invoiceNo && !hideCheckout && !pendingSale">
                                        <button type="button" class="btn btn-orange me-1" [disabled]="!allowVoid"
                                            (click)="voidLayawaySale()"
                                            *ngIf="!dayendOrOpenCashNotSaved && !dayendProcessedForToday">Void
                                            Layaway</button>
                                        <button type="button" class="btn btn-orange me-1" (click)="closeLayawaySale()"
                                            *ngIf="!dayendOrOpenCashNotSaved && !dayendProcessedForToday">Close
                                            Layaway</button>
                                    </div>
                                    <div class="col-md-12 text-end">
                                        <button type="button" class="btn btnAS me-1" *ngIf="displayChangeCardType"
                                            (click)="viewChangeCardTye()">Change Card Type</button>
                                        <button type="button" class="btn btnAS me-1" *ngIf="invoiceNo"
                                            (click)="viewPaymentDataForm()">View
                                            Payment Details</button>
                                        <button type="button" class="btn btnAS me-1" *ngIf="dispChangePayType"
                                            (click)="changePaymentDataForm()">Change Payment
                                            Type</button>
                                        <button type="button" class="btn btn-orange me-1"
                                            (click)="cancelSales()">Cancel</button>
                                        <button type="button" class="btn btn-success" (click)="openPaymentPage()"
                                            *ngIf="showCheckoutButton && !dayendOrOpenCashNotSaved && !dayendProcessedForToday">Checkout</button>
                                        <button type="button" class="btn btn-success" (click)="openPaymentPage()"
                                            *ngIf="currentMenu == '8' && !hideVoidButton && userTerminal && userTerminal != 0 && !dayendOrOpenCashNotSaved && !dayendProcessedForToday">Proceed
                                            to Void</button>
                                        <button type="button" class="btn btn-success" (click)="openPaymentPage()"
                                            *ngIf="currentMenu == '7' && userTerminal && userTerminal != 0 && !dayendOrOpenCashNotSaved && !dayendProcessedForToday">Proceed
                                            to Return</button>
                                        <button type="button" class="btn btn-success" (click)="savePendingSale()"
                                            *ngIf="currentMenu == '6' && userTerminal && userTerminal != 0">Save</button>
                                    </div>

                                    <div class="col-md-12 text-end" *ngIf="userSalesToolbar && lastInvoiceofUser">
                                        <div class="d-inline-block text-start">
                                            <label class="mb-0" style="color: red; font-size: 14px !important;">
                                                <span class="fw-bold">Last Invoice # :</span> {{
                                                lastInvoiceofUser?.MarketInvoiceNo }}
                                            </label>
                                            <br>
                                            <label class="mb-0" style="color: red; font-size: 14px !important;">
                                                <span class="fw-bold">Change Due :</span> {{
                                                lastInvoiceofUser?.ChangeAmount | currency }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="currentMenu == '8' || currentMenu == '7'">
                                <div class="col-md-6 text-start mt-2">
                                    <h6 style="font-weight: 600">
                                        {{ currentMenu == '8' ? 'Reason for Void' : 'Reason for Return' }}
                                    </h6>

                                    <div class="col-md-6 mt-2">
                                        <h6 class="fw-semibold mb-2">
                                            {{ currentMenu == '8' ? 'Void Amount' : 'Return Amount' }}
                                        </h6>
                                        <input type="text" class="form-control form-control-sm w-50 text-end"
                                            formControlName="returnAmount" readonly />
                                    </div>

                                    <div class="col-md-6 mt-2">
                                        <h6 class="fw-semibold mb-2">Reason</h6>
                                        <textarea class="form-control form-control-sm" rows="3"
                                            style="white-space: pre-line; text-align: left;"
                                            formControlName="returnReason" maxlength="100"
                                            [readonly]="!!savedReturnReason">
                                  </textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row" *ngIf="currentMenu == '5'">
                                <!-- Left side -->
                                <div class="col-md-12 col-lg-6">
                                    <div class="text-center mt-2 mb-3">
                                        <button type="button" class="btn btn-primary btn-sm" (click)="toggleSchedule()">
                                            {{ showInstallments ? 'Down Payment' : 'Payment Schedule' }}
                                        </button>
                                    </div>

                                    <!-- Down Payment Details -->
                                    <div *ngIf="!showInstallments">
                                        <div class="d-flex align-items-center mt-2">
                                            <label class="col-md-12 col-lg-4 form-label">Down payment% & Amt</label>
                                            <input class="col-3 form-control form-control-sm mx-2" style="width: 150px"
                                                type="text" formControlName="downPaymentPercent"
                                                (blur)="calculateLayaway()" appPercentageFormatter
                                                [readonly]="invoiceNo && !pendingSale" />
                                            <input class="col-3 form-control form-control-sm text-end"
                                                style="width: 150px" type="text" formControlName="downPaymentAmt"
                                                (blur)="calcDownpayPercBasedonAmt()"
                                                [readonly]="invoiceNo && !pendingSale" />
                                        </div>

                                        <div class="d-flex align-items-center mt-2">
                                            <label class="col-md-12 col-lg-4 form-label">Max Days & Expire Date</label>
                                            <input class="col-3 form-control form-control-sm mx-2" style="width: 150px"
                                                type="text" formControlName="downPaymentMaxDays"
                                                (blur)="calculateLayaway()" [readonly]="invoiceNo && !pendingSale"
                                                appNumericInput />
                                            <ejs-datepicker format='MM/dd/yyyy' formControlName="downPaymentExpiryDate"
                                                class="form-control p-0" [min]="currentDate" style="width: 23%;"
                                                [readonly]="invoiceNo && !pendingSale"></ejs-datepicker>
                                        </div>

                                        <div class="d-flex align-items-center mt-2">
                                            <label class="col-md-12 col-lg-4 form-label">Installment # & Bal Amt</label>
                                            <input class="col-3 form-control form-control-sm mx-2" style="width: 150px"
                                                type="text" formControlName="installmentNo" (blur)="calculateLayaway()"
                                                [readonly]="invoiceNo && !pendingSale" appNumericInput />
                                            <input class="col-3 form-control form-control-sm text-end"
                                                style="width: 150px" type="text" formControlName="paymentBal"
                                                readonly />
                                        </div>
                                    </div>

                                    <!-- Installments Schedule -->
                                    <div *ngIf="showInstallments">
                                        <table class="table table-bordered table-sm mt-2">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Installment Date</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let installment of installments; let i = index">
                                                    <td>{{ i + 1 }}</td>
                                                    <td>
                                                        <input type="text" class="form-control form-control-sm"
                                                            [(ngModel)]="installment.date"
                                                            [ngModelOptions]="{ standalone: true }" />
                                                    </td>
                                                    <td class="text-end">
                                                        {{ installment.amount | currency }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </form>
            </div>
            <div class="modal fade" id="invoiceModal" #invoiceModal aria-hidden="true"
                aria-labelledby="invoiceModalToggleLabel" tabindex="-1">
                <div class="modal-dialog modal-dialog-centered modal-xl">
                    <form class="modal-content" [formGroup]="invoiceForm" (ngSubmit)="$event.preventDefault()">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="invoiceModalToggleLabel">Invoice Search</h1>
                            <button type="button" class="btn-close" (click)="closeInvoiceListModal()"></button>
                        </div>
                        <div class="modal-body">
                            <div class="row g-3">
                                <div class="col-md-6 col-lg-3">
                                    <label class="form-label">Invoice #</label>
                                    <input type="text" class="form-control" placeholder=""
                                        formControlName="invoiceNumber" />
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <label class="form-label">From</label>
                                    <input type="date"
                                           class="form-control"
                                           formControlName="invoiceFromDate" />
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <label class="form-label">To</label>
                                    <input type="date"
                                           class="form-control"
                                           formControlName="invoiceToDate" />
                                </div>
                                <div class="col-md-6 col-lg-3 d-flex align-items-center">
                                    <div class="form-check mt-4">
                                        <input type="checkbox"
                                               class="form-check-input"
                                               id="invoiceDateFilter"
                                               formControlName="dateFilter" />
                                        <label class="form-check-label" for="invoiceDateFilter">
                                            Date Filter
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <label class="form-label">Terminal Name</label>
                                    <select class="form-select" formControlName="terminalName">
                                        <option value="ALL">ALL</option>
                                        <option *ngFor="let item of defaultTerminalSelection"
                                                [value]="item.Name">
                                            {{ item.Name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <label class="form-label">Invoice Amount</label>
                                    <input type="text" class="form-control" placeholder="" inputmode="decimal"
                                        formControlName="invoiceAmount" (keypress)="numberOnlyMaxDecimals($event, 2)"
                                        (focus)="onInvoiceAmountFocus()" (blur)="onInvoiceAmountBlur()" />
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <label class="form-label">Sales Type</label>
                                    <select class="form-select" formControlName="saleType">
                                        <option value="0">ALL</option>
                                        <option *ngFor="let item of salesType" [value]="item.SalesTypeId">
                                            {{item.SalesTypeDesc}}</option>
                                    </select>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <label class="form-label">First Name</label>
                                    <input type="text" class="form-control" placeholder=""
                                        formControlName="firstName" />
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <label class="form-label">Last Name</label>
                                    <input type="text" class="form-control" placeholder="" formControlName="lastName" />
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <label class="form-label">User Name</label>
                                    <select class="form-select" formControlName="userId">
                                        <option value="0">ALL</option>
                                        <option *ngFor="let item of userList" [value]="item.UserId">{{item.UserName}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-end mt-2">
                                    <button type="button" class="btn btnAS btn-sm"
                                        (click)="loadInvoiceList()">OK</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-startmt-2">
                                    <p>Invoice Details</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-startmt-2">
                                    <ejs-grid height="300" #gridInvoice [dataSource]='invoiceList'
                                        [allowSelection]="true" [selectionSettings]="{ type: 'Single', mode: 'Row' }"
                                        (recordDoubleClick)="onInvoiceDoubleClick($event)"
                                        (rowSelected)="onInvoiceRowSelected($event)">
                                        <e-columns>
                                            <e-column field="MarketInvoiceNo" headerText="Invoice #"
                                                width="120"></e-column>
                                            <e-column field="InvoiceDate" headerText="Date" width="120"></e-column>
                                            <e-column field="InvoiceSaleType" headerText="Sale Type"
                                                width="130"></e-column>
                                            <e-column field="CustomerName" headerText="Customer Name"
                                                width="150"></e-column>
                                            <e-column field="UserName" headerText="User Name" width="130"></e-column>
                                            <e-column field="Status" headerText="Status" width="100"></e-column>
                                            <e-column headerText="Layaway Info" width="150" textAlign="Center">
                                                <ng-template #template let-data>
                                                    <button type="button" class="layaway-btn btn-orange w-100 h-100"
                                                        (click)="openLayawayInfo(data); $event.stopPropagation();">
                                                        Preview
                                                    </button>
                                                </ng-template>
                                            </e-column>
                                        </e-columns>
                                    </ejs-grid>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btnAS me-1" [disabled]="!selectedInvoiceRow"
                                (click)="selectedInvoiceData()">OK</button>
                            <button type="button" class="btn btn-orange me-1"
                                (click)="closeInvoiceListModal()">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="modal fade" id="vendorModal" #vendorModal tabindex="-1" aria-labelledby="vendorModalLabel"
                aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" data-bs-focus="false">
                <div class="modal-dialog modal-xl modal-dialog-centered">
                    <div class="modal-content">

                        <div class="modal-header">
                            <h5 class="modal-title" id="vendorModalLabel">Vendor Search</h5>
                            <button type="button" class="btn-close" (click)="onVendorModalClose()"></button>
                        </div>

                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
                                            *ngIf="!allowPossalesWithOutBooking && showVendorSearch ">
                                            <app-pos-vendor-search #posVendorSearch (vendorData)="VendorInfo($event)">
                                            </app-pos-vendor-search>
                                        </div>
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
                                            *ngIf="allowPossalesWithOutBooking && showVendorSearch ">
                                            <app-vendor-search [isVendorPopUp]="true" #vendorSearch
                                                [VendorFilterOption]="VendorFilterOption"
                                                (vendorSearchRoute)="VendorInfo($event)">
                                            </app-vendor-search>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-orange me-1"
                                (click)="onVendorModalClose()">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="customerModal" #customerModal tabindex="-1" aria-labelledby="customerModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-centered">
                    <div class="modal-content">

                        <div class="modal-header">
                            <h5 class="modal-title" id="customerModalLabel" *ngIf="customerSearch">Customer Search</h5>
                            <h5 class="modal-title" id="customerModalLabel" *ngIf="!customerSearch">Customer Information
                            </h5>
                            <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                        </div>

                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3">
                                            <app-pos-customer-search *ngIf="customerDataPopup"
                                                [customerSearch]="customerSearch" [newForm]="newCustomer"
                                                [customerId]="customerId" (customerData)="CustomerInfo($event)"
                                                (closeCustomerInfoModal)="closeCustomerInfoModal($event)">
                                            </app-pos-customer-search>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer" *ngIf="customerSearch">
                            <button type="button" class="btn btn-orange me-1"
                                (click)="closeCustomerInfoModal($event)">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="shipperModal" #shipperModal tabindex="-1"
                aria-labelledby="shipperModalModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-centered">
                    <div class="modal-content">

                        <div class="modal-header">
                            <h5 class="modal-title" id="shipperModalModalLabel" *ngIf="shipperSearch">Shipper Search
                            </h5>
                            <h5 class="modal-title" id="shipperModalModalLabel" *ngIf="!shipperSearch">Shipping
                                Information
                            </h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3">
                                            <app-pos-shipper-search [shipperSearch]="shipperSearch"
                                                [newForm]="newShipper" [shipperId]="shipperId"
                                                (shipperData)="ShipperInfo($event)"
                                                (closeShipperInfoModal)="closeShipperInfoModal($event)">
                                            </app-pos-shipper-search>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="modal-footer" *ngIf="customerSearch">
                            <button type="button" class="btn btn-orange me-1" data-bs-dismiss="modal">Close</button>
                        </div> -->
                    </div>
                </div>
            </div>

            <div class="modal fade" id="invoiceEditModal" #invoiceEditModal tabindex="-1"
                aria-labelledby="invoiceEditModalToggleLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content" [formGroup]="invoiceEditForm">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="invoiceModalToggleLabel" *ngIf="posTransactionByVendor">
                                Changing of
                                {{'Vendor Id' |
                                wordReplace}}</h1>
                            <h1 class="modal-title fs-5" id="invoiceModalToggleLabel" *ngIf="!posTransactionByVendor">
                                 {{ 'Changing Booth ID' | wordReplace }}</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                (click)="closeInvoiceEditModel()"></button>
                        </div>

                        <div class="modal-body">
                            <!-- Radio Options -->
                            <div class="mb-1">
                                <div class="d-flex gap-3">
                                    <div class="form-check" *ngIf="posTransactionByVendor">
                                        <input class="form-check-input" type="radio"
                                            formControlName="editCustomerOrStock" value="customer" id="changeCustomer"
                                            name="editCustomerOrStock" (change)="changeCustomerOrStock()">
                                        <label class="form-check-label" for="changeCustomer">{{'Change Vendor Id' |
                                            wordReplace}}</label>
                                    </div>
                                    <div class="form-check" *ngIf="!posTransactionByVendor">
                                        <input class="form-check-input" type="radio"
                                            formControlName="editCustomerOrStock" value="boothId" id="changeBoothId"
                                            name="editCustomerOrStock" (change)="changeCustomerOrStock()">
                                        <label class="form-check-label" for="changeBoothId">{{ 'Change Booth ID' | wordReplace }}</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio"
                                            formControlName="editCustomerOrStock" value="stock" id="changeStock"
                                            name="editCustomerOrStock" (change)="changeCustomerOrStock()">
                                        <label class="form-check-label" for="changeStock">Change Stock</label>
                                    </div>
                                </div>
                            </div>

                            <fieldset class="border p-3 rounded mb-3 position-relative">
                                <legend class="float-none w-auto px-3 py-1 col-form-label fw-bold ">
                                    Item Details
                                </legend>

                                <div class="row g-3">
                                    <div class="col-md-3" *ngIf="posTransactionByVendor">
                                        <label class="col-form-label">Invoice</label>
                                        <input type="text" class="form-control" formControlName="invoiceNumber" />
                                    </div>
                                </div>
                                <div class="row g-3">
                                    <div class="col-md-3" *ngIf="posTransactionByVendor">
                                        <label class="col-form-label">{{'Existing Vendor ID' | wordReplace}}</label>
                                        <input type="text" class="form-control" formControlName="existingVendorId" />
                                    </div>
                                    <div class="col-md-3" *ngIf="!posTransactionByVendor">
                                        <label class="col-form-label">{{'Existing Booth Id' | wordReplace }}</label>
                                        <input type="text" class="form-control" formControlName="existingBoothId" />
                                    </div>
                                    <div class="col-md-3">
                                        <label class="col-form-label">Stock ID</label>
                                        <input type="text" class="form-control" formControlName="existingStockId" />
                                    </div>
                                    <div class="col-md-3">
                                        <label class="col-form-label">Qty</label>
                                        <input type="text" class="form-control" formControlName="existingQty" />
                                    </div>
                                    <div class="col-md-3">
                                        <label class="col-form-label">Rate/Unit</label>
                                        <input type="text" class="form-control" formControlName="existingRate" />
                                    </div>
                                    <div class="col-md-12">
                                        <label class="col-form-label">Item Description</label>
                                        <input type="text" class="form-control"
                                            formControlName="existingItemDescription" />
                                    </div>
                                </div>
                            </fieldset>

                            <!-- Modified Section -->
                            <fieldset class="border p-3 rounded mb-3 position-relative">
                                <legend class="float-none w-auto px-3 py-1 col-form-label fw-bold">
                                    Modified Details
                                </legend>
                                <div class="row g-3">
                                    <div class="col-md-3" *ngIf="posTransactionByVendor">
                                        <label class="col-form-label">{{'New Vendor ID' | wordReplace}}</label>
                                        <input type="text" class="form-control" formControlName="newVendorId"
                                            (blur)="getVendorInfoByMarketVendorId(invoiceEditForm.get('newVendorId')?.value)">
                                    </div>
                                    <div class="col-md-3" *ngIf="!posTransactionByVendor">
                                        <label class="col-form-label">{{'New Booth Id' | wordReplace }}</label>
                                        <input type="text" class="form-control" formControlName="newBoothId">
                                    </div>
                                    <div class="col-auto">
                                        <label class="col-form-label">&nbsp;</label>
                                        <button type="button" class="btn btn-dark-custom btn-sm w-100"
                                            [disabled]="invoiceEditForm.get('editCustomerOrStock')?.value === 'stock'"
                                            (click)="setVendorValue();openModalById('vendorModal')">
                                            <img src="./assets/images/search.svg" class="img-fluid" />
                                        </button>
                                    </div>
                                    <div class="col-md-4" *ngIf="showCommissiononPos">
                                        <label class="col-form-label">Comm %</label>
                                        <input type="text" class="form-control" formControlName="newComm">
                                    </div>
                                    <div class="col-md-4">
                                        <label class="col-form-label">New Stock ID</label>
                                        <input type="text" class="form-control" formControlName="newStockId"
                                            (blur)="validateNewStockId()">
                                    </div>
                                </div>

                                <div class="row g-3">
                                    <div class="col-md-12">
                                        <label class="col-form-label">Item Description</label>
                                        <input type="text" class="form-control" formControlName="newItemDescription">
                                    </div>
                                </div>

                                <div class="row g-3">
                                    <div class="col-md-12">
                                        <label class="col-form-label">Reason for Change</label>
                                        <textarea class="form-control" rows="3"
                                            formControlName="changeReason"></textarea>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btnAS me-1"
                                (click)="updateInvoiceItemDetails()">Save</button>
                            <button type="button" class="btn btn-orange me-1"
                                (click)="closeInvoiceEditModel()">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="layawayVoidModel" #layawayVoidModel tabindex="-1"
                aria-labelledby="layawayVoidModelToggleLabel" aria-hidden="true">
                <div class="modal-dialog modal-md modal-dialog-centered">
                    <div class="modal-content" [formGroup]="voidLayawayForm">

                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="layawayVoidModelToggleLabel">Void Layaway</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                (click)="closeInvoiceEditModel()"></button>
                        </div>

                        <div class="modal-body">
                            <div class="row mb-2">
                                <label class="col-sm-8 col-form-label">Down Payment Received</label>
                                <div class="col-sm-4">
                                    <input type="text" formControlName="downPaymentReceived" class="form-control" />
                                </div>
                            </div>

                            <div class="row mb-2">
                                <label class="col-sm-8 col-form-label">Installments Payments Received Till Date</label>
                                <div class="col-sm-4">
                                    <input type="text" formControlName="installmentPayReceived" class="form-control" />
                                </div>
                            </div>

                            <div class="row mb-2">
                                <label class="col-sm-8 col-form-label">Latest Installment Payment Received</label>
                                <div class="col-sm-4">
                                    <input type="text" formControlName="LastestinstallmentReceived"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="row mb-2">
                                <label class="col-sm-8 col-form-label">Total Payment Received</label>
                                <div class="col-sm-4">
                                    <input type="text" formControlName="TotalPaymentReceived" class="form-control" />
                                </div>
                            </div>

                            <fieldset class="border p-3 rounded mb-3 position-relative"
                                *ngIf="layawayReceiptIds?.length > 1">
                                <legend class="float-none w-auto px-3 py-1 col-form-label bg-light">
                                    Void Receipt
                                </legend>

                                <div class="row mb-2">
                                    <label class="col-sm-4 col-form-label">Receipt</label>
                                    <div class="col-sm-8">
                                        <select class="form-select" style="width: 160px;"
                                            formControlName="LayawayReceipt" (change)="loadLayawayReceiptAmount()">
                                            <option *ngFor="let item of layawayReceiptIds" [value]="item.SalesRectId">
                                                {{ item.SalesRectId }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <label class="col-sm-4 col-form-label">Receipt Amount</label>
                                    <div class="col-sm-8">
                                        <input type="text" formControlName="LayawayReceiptAmount"
                                            class="form-control" />
                                    </div>
                                </div>
                            </fieldset>

                            <div class="row mb-2">
                                <label class="col-sm-4 col-form-label">Reason For Void</label>
                                <div class="col-sm-8">
                                    <textarea formControlName="reasonForLayawayVoid" rows="3"
                                        class="form-control"></textarea>
                                </div>
                            </div>

                            <label *ngIf="layawayReceiptIds?.length == 1" style="color: red;">Installment Receipts not
                                found</label>

                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-orange me-1" (click)="voidLayawayDetails()">Void Latest
                                Installment</button>
                            <button type="button" class="btn btn-orange me-1" (click)="voidEntireLayaway()">Void Entire
                                Layaway</button>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<app-pos-payment *ngIf="!salesPageVisible" [paymentData]="paymentData" (clearPaymentData)="clearPaymentPage($event)"
    (closePaymentPage)="closePaymentPage($event)"></app-pos-payment>

<div class="modal fade" id="modalDiscountCoupon" tabindex="-1" aria-labelledby="modalDiscountCouponLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalDiscountCouponLabel">Discount Coupon</h1>
                <button type="button" class="btn-close" (click)="closeDiscountModal()"></button>
            </div>
            <div class="modal-body">
                <label class="mb-2" style="font-weight: 600">Enter</label>
                <div class="row g-2 align-items-center">
                    <div class="col-auto">
                        <label for="exampleInput" class="col-form-label">Discount %</label>
                    </div>
                    <div class="col-auto">
                        <input class="form-control" id="exampleInput" [(ngModel)]="discountCouponPercent"
                            appPercentageFormatter>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btnAS" (click)="applyCouponDiscount()">OK</button>
                <button type="button" class="btn btn-orange me-1" (click)="closeDiscountModal()">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalInvoiceEmail" tabindex="-1" aria-labelledby="modalInvoiceEmailLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalInvoiceEmailLabel">Email Address</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row g-2 align-items-center">
                    <div class="col-auto">
                        <label for="exampleInput" class="col-form-label">Email Address</label>
                    </div>
                    <div class="col-auto">
                        <input type="email" class="form-control" placeholder="Email Address"
                            [(ngModel)]="customerEmailAdd" name="customerEmailAdd" required email
                            #emailCtrl="ngModel" />

                        <small class="text-danger" *ngIf="emailCtrl.invalid && emailCtrl.touched">
                            Please enter a valid email address
                        </small>
                    </div>

                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btnAS" (click)="emailInvoiceToCust()"
                    [disabled]="emailCtrl.invalid">OK</button>
                <button type="button" class="btn btn-orange me-1" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalOpenCash" #modalOpenCash aria-hidden="true" aria-labelledby="modalOpenCashLabel"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <div class="modal-header">

            </div>
            <div class="modal-body">
                <app-ops-opening-cash-drawer-amount *ngIf="openCashNotSet" [hideOpenCashTopMenu]="hideOpenCashTopMenu"
                    (openCashSaved)="openCashSaved($event)"></app-ops-opening-cash-drawer-amount>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-orange" (click)="btnCloseOpenCash()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- Receipt Modal -->
<div class="modal fade" id="printReceiptPopup" #printReceiptPopup tabindex="-1" aria-labelledby="printReceiptModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="printReceiptModalLabel">Preview</h5>
                <button type="button" class="btn-close" (click)="closeModalById('printReceiptPopup')"></button>
            </div>

            <div class="modal-body">
                <!-- Loading Spinner -->
                <div class="text-center py-5" *ngIf="loading; else pdfViewReceipt">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-muted">Loading receipt...</p>
                </div>

                <!-- PDF View -->
                <ng-template #pdfViewReceipt>
                    <iframe *ngIf="receiptUrl" [src]="receiptUrl" width="100%" height="500px" frameborder="0"></iframe>
                </ng-template>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-orange"
                    (click)="closeModalById('printReceiptPopup')">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Change Payment Type Modal -->
<div class="modal fade" id="changePaymentType" #changePaymentType tabindex="-1" aria-labelledby="changePaymentTypeLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content" [formGroup]="invoiceChangePaymentForm">
            <div class="modal-header">
                <div class="d-flex align-items-center w-100">
                    <h6 class="modal-title mb-0">Change POS Payment Type</h6>
                    <div class="ms-auto d-flex gap-2">
                        <span class="badge bg-light text-dark border py-2 form-control">
                            Invoice #: {{invoiceNo}}
                        </span>
                        <span class="badge bg-light text-dark border py-2 form-control">
                            Invoice Amount: {{ invoicePayDataForm.get('invoiceTotAmt')?.value }}
                        </span>
                    </div>
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal"></button>
                </div>
            </div>
            <div class="modal-body">
                <div class="border rounded p-3 shadow-sm mt-2">
                    <h6 class="fw-bold mb-3">Current Payment Details</h6>

                    <!-- Header -->
                    <div class="row fw-bold mb-2">
                        <div class="col-3">Payment Type</div>
                        <div class="col-3 text-end">Amount</div>
                        <div class="col-3">Number</div>
                        <div class="col-3"></div>
                    </div>

                    <!-- Cash -->
                    <div class="row align-items-center mb-2">
                        <div class="col-3">Cash Paid</div>
                        <div class="col-3">
                            <input type="text" class="form-control form-control-sm text-end"
                                formControlName="invsChngPayCashPaid" readonly>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-3"></div>
                    </div>

                    <!-- Check -->
                    <div class="row align-items-center mb-2">
                        <div class="col-3">Check</div>
                        <div class="col-3">
                            <input type="text" class="form-control form-control-sm text-end"
                                formControlName="invsChngPayCheckPaid" readonly>
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control form-control-sm" formControlName="invsChngPayCheckNo"
                                readonly>
                        </div>
                        <div class="col-3"></div>
                    </div>

                    <!-- Credit / Debit Card -->
                    <div class="row align-items-center mb-2">
                        <div class="col-3">Credit / Debit Card</div>
                        <div class="col-3">
                            <input type="text" class="form-control form-control-sm text-end"
                                formControlName="invsChngPayCCPaid" readonly>
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control form-control-sm" value="**** **** ****" readonly>
                        </div>
                        <div class="col-3 d-flex gap-1">
                        </div>
                    </div>

                    <!-- Traveler Check -->
                    <div class="row align-items-center mb-2">
                        <div class="col-3">Traveler Check</div>
                        <div class="col-3">
                            <input type="text" class="form-control form-control-sm text-end"
                                formControlName="invsChngPayTravCheckPaid" readonly>
                        </div>
                        <div class="col-3">
                            <input type="text" class="form-control form-control-sm"
                                formControlName="invsChngPayTravCheckNo" readonly>
                        </div>
                        <div class="col-3"></div>
                    </div>

                    <!-- Gift Certificate -->
                    <div class="row align-items-center">
                        <div class="col-3">Gift Certificate</div>
                        <div class="col-3">
                            <input type="text" class="form-control form-control-sm text-end" value="$0.00" readonly>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-3"></div>
                    </div>
                </div>
                <div class="border rounded p-2 shadow-sm mt-2">
                    <h6 class="fw-bold text-primary mb-3">
                        Modified Payment Options
                    </h6>

                    <!-- Header -->
                    <div class="row fw-semibold mb-2 text-muted">
                        <div class="col-md-3">Payment Type</div>
                        <div class="col-md-3 text-end">Amount</div>
                        <div class="col-md-3"></div>
                        <div class="col-md-3"></div>
                    </div>

                    <!-- Cash Paid -->
                    <div class="row align-items-center mb-2">
                        <div class="col-md-3">Cash Paid</div>
                        <div class="col-md-3">
                            <input type="text" class="form-control text-end" formControlName="invsChngPayModifiedCash"
                                (keypress)="numberOnly($event)" (change)="calculateTotalPaid()"
                                appRemoveCurrencyFormatting
                                (blur)="applyCurrency(this.invoiceChangePaymentForm.get('invsChngPayModifiedCash'))">
                        </div>
                        <div class="col-md-3"></div>
                        <div class="col-md-3"></div>
                    </div>

                    <!-- Check -->
                    <div class="row align-items-center mb-2">
                        <div class="col-md-3">Check</div>
                        <div class="col-md-3">
                            <input type="text" class="form-control text-end" formControlName="invsChngPayModifiedCheck"
                                (keypress)="numberOnly($event)" (change)="calculateTotalPaid()"
                                appRemoveCurrencyFormatting
                                (blur)="applyCurrency(this.invoiceChangePaymentForm.get('invsChngPayModifiedCheck'))">
                        </div>
                        <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Check Number"
                                formControlName="invsChngPayModifiedCheckNo">
                        </div>
                        <div class="col-md-3"></div>
                    </div>

                    <!-- Credit / Debit Card -->
                    <div class="row align-items-center mb-2">
                        <div class="col-md-3">Credit/Debit Card</div>

                        <div class="col-md-3">
                            <input type="text" class="form-control text-end" formControlName="invsChngPayModifiedCC"
                                (keypress)="numberOnly($event)" (change)="calculateTotalPaid()"
                                appRemoveCurrencyFormatting (input)="enteredCCModifiedAmount()"
                                (blur)="applyCurrency(this.invoiceChangePaymentForm.get('invsChngPayModifiedCC'))">
                        </div>

                        <div class="col-md-3">
                            <select class="form-control" formControlName="invsChngPayModifiedCardType"
                                (change)="checkPaymentType()">
                                <option *ngFor="let item of creditCardList" [value]="item.CreditCardTypeId">
                                    {{item.CreditCardTypeDesc}}
                                </option>
                            </select>
                        </div>

                        <div class="col-md-3 d-flex gap-2"></div>
                    </div>

                    <!-- Traveler Check -->
                    <div class="row align-items-center mb-3">
                        <div class="col-md-3">Traveler Check</div>

                        <div class="col-md-3">
                            <input type="text" class="form-control text-end"
                                formControlName="invsChngPayModifiedTravCheck" appRemoveCurrencyFormatting
                                (change)="calculateTotalPaid()"
                                (blur)="applyCurrency(this.invoiceChangePaymentForm.get('invsChngPayModifiedTravCheck'))"
                                appCurrencyFormatter>
                        </div>

                        <div class="col-md-3">
                            <input type="text" class="form-control" placeholder="Check Number"
                                formControlName="invsChngPayModifiedTravCheckNo">
                        </div>

                        <div class="col-md-3">
                        </div>
                    </div>

                    <!-- Total Paid -->
                    <div class="row fw-bold border-top pt-2">
                        <div class="col-md-9 text-end">Total Paid</div>
                        <div class="col-md-3">
                            <input type="text" class="form-control text-end fw-bold"
                                formControlName="invsChngPayModifiedTotalPaid">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btnAS" (click)="saveChangePaymentType()">Save</button>
                <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- View Payment Data Modal -->
<div class="modal fade" id="viewPaymentData" #viewPaymentData tabindex="-1" aria-labelledby="viewPaymentDataLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content" [formGroup]="invoicePayDataForm">
            <div class="modal-header">
                <div class="d-flex align-items-center w-100">
                    <h6 class="modal-title mb-0">View Payment Details</h6>
                    <div class="ms-auto d-flex gap-2">
                        <span class="badge bg-light text-dark border py-2 form-control">
                            Invoice #: {{invoiceNo}}
                        </span>
                        <span class="badge bg-light text-dark border py-2 form-control">
                            Invoice Amount: {{ invoicePayDataForm.get('invoiceTotAmt')?.value }}
                        </span>
                    </div>
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal"></button>
                </div>
            </div>
            <div class="modal-body">
                <div class="border rounded p-3 shadow-sm">
                    <div class="row">

                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">Net Price</label>
                            <input type="text" class="form-control text-end" formControlName="invNetPrice">
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">Other charges</label>
                            <input type="text" class="form-control text-end" formControlName="invOtherCharge">
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">Sales tax</label>
                            <input type="text" class="form-control text-end" formControlName="invSalesTax">
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">{{secondLevelTaxName}}</label>
                            <input type="text" class="form-control text-end" formControlName="invSecLvlTax">
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">Balance Due</label>
                            <input type="text" class="form-control fw-bold text-end" formControlName="invBalanceDue">
                        </div>

                    </div>
                </div>
                <div class="border rounded p-3 shadow-sm mt-2">
                    <div class="row">
                        <div class="col-12 text-start">
                            <h6>Payment Method</h6>
                        </div>
                    </div>
                    <div class="row g-3">
                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">Cash</label>
                            <input type="text" class="form-control text-end" formControlName="invCashPaid">
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">Check</label>
                            <input type="text" class="form-control text-end" formControlName="invCheckPaid">
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">Check #</label>
                            <input type="text" class="form-control text-end" formControlName="invCheckNo">
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">Credit/Debit</label>
                            <input type="text" class="form-control fw-bold text-end" formControlName="invCCPaid">
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">CC Charges</label>
                            <input type="text" class="form-control fw-bold text-end" formControlName="invCCCharges">
                        </div>

                        <div class="col-md-6 col-lg-3" *ngIf="invoicePayDataForm.get('invCardType').value">
                            <label class="form-label fw-semibold">Card Type</label>
                            <input type="text" class="form-control fw-bold text-start" formControlName="invCardType"
                                readonly>
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">{{travelerCheckTerm}}</label>
                            <input type="text" class="form-control text-end" formControlName="invTravelerCheckPaid">
                        </div>

                        <div class="col-md-6 col-lg-3">
                            <label class="form-label fw-semibold">{{travelerCheckTerm}} #</label>
                            <input type="text" class="form-control text-end" formControlName="invTravelerCheckNo">
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="changeCardType" #changeCardType tabindex="-1" aria-labelledby="changeCardTypeLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content" [formGroup]="changeCardTypeForm">

            <div class="modal-header">
                <div class="d-flex align-items-center w-100">
                    <h6 class="modal-title mb-0">Changing of Card Type</h6>
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal"></button>
                </div>
            </div>

            <div class="modal-body">
                <fieldset class="border p-2 mb-3">
                    <legend class="w-auto px-2 small text-muted">Existing Payment Details</legend>

                    <div class="form-group row mb-2">
                        <label class="col-5 col-form-label">Invoice #</label>
                        <div class="col-7">
                            <input type="text" class="form-control" formControlName="changeCardTypeInvoice" disabled>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <label class="col-5 col-form-label">CC / DC Payment</label>
                        <div class="col-7">
                            <input type="text" class="form-control text-right" formControlName="changeCardTypeCCAmt"
                                disabled>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <label class="col-5 col-form-label">Card Type</label>
                        <div class="col-7">
                            <input type="text" class="form-control" formControlName="changeCardTypeCurrentCard"
                                disabled>
                        </div>
                    </div>
                </fieldset>

                <div class="form-group row">
                    <label class="col-5 col-form-label font-weight-bold">
                        Change Card Type To
                    </label>
                    <div class="col-7">
                        <select class="form-control" formControlName="changeCardTypeNewCard">
                            <option *ngFor="let item of creditCardList" [value]="item.CreditCardTypeId">
                                {{item.CreditCardTypeDesc}}
                            </option>
                        </select>
                    </div>
                </div>

            </div>

            <!-- Modal Footer -->
            <div class="modal-footer py-2">
                <button type="button" class="btn btnAS" (click)="saveChangeCardType()">Save</button>
            </div>

        </div>
    </div>
</div>

<div *ngIf="processPayment">
    <app-payment [VendorId]="vendorId" keyedInTransaction="true"
        [CCAmount]="this.invoiceChangePaymentForm.get('invsChngPayModifiedCC').value"
        [TransactionType]="transactionType" [voidPayment]="voidPayment" (PaymentResponse)="paymentResponse($event)"
        [VerifoneId]="verifoneId" (ClosePaymentPage)="ClosePaymentPage($event)" [PosRequest]="PosRequest"></app-payment>
</div>


<!-- Consignment Inventory Modal -->
<div class="modal fade" id="consignmentInventory" #consignmentInventory tabindex="-1"
    aria-labelledby="consignmentInventoryLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="d-flex align-items-center w-100">
                    <h6 class="modal-title mb-0">Consignment Item/Online Sales/Inventory Item Search</h6>
                    <button type="button" class="btn-close ms-auto" (click)="closeConsignmentModel()"></button>
                </div>
            </div>
            <div class="modal-body">
                <div class="vendorSearch">
                    <!-- Filter Section -->
                    <div class="row mb-2 align-items-end">

                        <!-- Search Field -->
                        <div class="col-md-3">
                            <label>Search Field</label>
                            <select class="form-select form-select-sm" [(ngModel)]="searchField">
                                <option [value]="1">{{'Booth Id' | wordReplace }}</option>
                                <option [value]="2">Product Name</option>
                                <option [value]="4">Stock Id</option>
                                <option [value]="5">{{'Vendor Id' | wordReplace }}</option>
                                <option [value]="6">{{'Vendor Name' | wordReplace }}</option>
                            </select>
                        </div>

                        <!-- Search Value -->
                        <div class="col-md-3">
                            <label>Search Value</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="searchValue"
                                (keyup)="resetAndLoad()">
                        </div>


                        <!-- Radio Buttons -->
                        <div class="col-md-4">
                            <label class="d-block">Type</label>

                            <div class="d-flex gap-3 mt-1">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="inventoryType"
                                        [(ngModel)]="inventoryType" value="All"
                                        (change)="getConsignmentProductForPOS()">
                                    <label class="form-check-label">All</label>
                                </div>

                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="inventoryType"
                                        [(ngModel)]="inventoryType" value="Consignment"
                                        (change)="getConsignmentProductForPOS()">
                                    <label class="form-check-label">Consignment</label>
                                </div>

                                <div class="form-check" *ngIf="enableInventory">
                                    <input class="form-check-input" type="radio" name="inventoryType"
                                        [(ngModel)]="inventoryType" value="Inventory"
                                        (change)="getConsignmentProductForPOS()">
                                    <label class="form-check-label">Inventory</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Scrollable Table -->
                    <div class="row">
                        <div class="col-12">
                            <div class="scroll_outer" style="height:400px; overflow-y:auto;"
                                (scroll)="onInventoryScroll($event)">
                                <table class="table table-striped text-center mb-0">
                                    <thead style="position: sticky; top: 0; z-index: 9; background-color: #fff;">
                                        <tr>
                                            <th style="width: 6%" (click)="sort('StockId')">Stock ID</th>
                                            <th style="width: 10%" (click)="sort('ProductName')">Product Name</th>
                                            <th style="width: 10%" (click)="sort('VendorId')">{{'Vendor Id' | wordReplace }}</th>
                                            <th style="width: 20%" (click)="sort('VendorName')">{{'Vendor Name' | wordReplace }}</th>
                                            <th style="width: 10%" (click)="sort('BoothId')">{{'Booth Id' | wordReplace }}</th>
                                            <th style="width: 8%">Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of consignmentItems" class="customer-row"
                                            (click)="getConsignmentItemData(item)">
                                            <td>{{ item.StockId }}</td>
                                            <td>{{ item.ProductName }}</td>
                                            <td>{{ item.VendorAlphaId }}</td>
                                            <td class="text-left">{{ item.VendorName }}</td>
                                            <td>{{item.ConsignSpaceId}}</td>
                                            <td>{{ item.Price | customCurrency }}</td>
                                        </tr>
                                        <tr *ngIf="consignmentItems.length == 0">
                                            <td colspan="12" style="text-align: center;">No records found</td>
                                        </tr>
                                        <tr *ngIf="isLoadingMoreInventory">
                                            <td colspan="12" style="text-align: center;">Loading more...</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>